import { animate, style, transition, trigger } from '@angular/animations';
import { ComponentType } from '@angular/cdk/portal';
import {
  Component,
  Inject,
  InjectionToken,
  Injector,
  HostListener,
  TemplateRef,
  ViewChild,
  ElementRef,
  AfterViewInit,
  EventEmitter,
} from '@angular/core';
import { DrawerPanelRef } from '../../services/drawer-panel.ref';

export interface DrawerPanelConfig {
  component: ComponentType<any> | TemplateRef<any>;
  drawerRef: DrawerPanelRef;
  onHide?: EventEmitter<void>;
}

export const DRAWER_PANEL_CONFIG = new InjectionToken<DrawerPanelConfig>('DRAWER_PANEL_COMPONENT');
export const DRAWER_PANEL_DATA = new InjectionToken<{}>('DRAWER_PANEL_DATA');

@Component({
    templateUrl: './drawer-panel.component.html',
    styleUrls: ['./drawer-panel.component.scss'],
    animations: [
        trigger('slideInOut', [
            transition(':enter', [style({ transform: 'translateX(100%)' }), animate('200ms ease-in', style({ transform: 'translateX(0%)' }))]),
            transition(':leave', [animate('200ms ease-in', style({ transform: 'translateX(100%)' }))]),
        ]),
    ],
    standalone: false
})
export class DrawerPanelComponent implements AfterViewInit {
  dataInjector = Injector.create({
    providers: [
      {
        provide: DRAWER_PANEL_DATA,
        useValue: this.data,
      },
      {
        provide: DrawerPanelRef,
        useValue: this.config.drawerRef,
      },
    ],
    parent: this.injector,
  });

  @ViewChild('container') container: ElementRef<HTMLDivElement>;

  onkeydown(event: KeyboardEvent) {
    if (event.which === 27) {
      event.preventDefault();
      event.stopPropagation();
      this.close();
      return false;
    }
  }

  constructor(
    private injector: Injector,
    @Inject(DRAWER_PANEL_CONFIG) public config: DrawerPanelConfig,
    @Inject(DRAWER_PANEL_DATA) private data: any,
  ) {}

  ngAfterViewInit() {
    this.container.nativeElement.focus();
  }

  isTemplateRef(componentOrTemplateRef: DrawerPanelConfig['component']) {
    return componentOrTemplateRef instanceof TemplateRef;
  }

  close() {
    this.config.drawerRef.close();
    this.config.onHide && this.config.onHide.emit();
  }
}
